<template>
  <div class="platform-compare">
    <div class="chart-radar" ref="radarChart"></div>
    <div class="chart-bar" ref="barChart"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts/core'
import { RadarChart, BarChart } from 'echarts/charts'
import { TooltipComponent, LegendComponent, GridComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { platformData } from '../mock/data'

echarts.use([RadarChart, BarChart, TooltipComponent, LegendComponent, GridComponent, CanvasRenderer])

export default {
  name: 'PlatformCompare',
  data() {
    return {
      radarChart: null,
      barChart: null
    }
  },
  mounted() {
    this.initRadarChart()
    this.initBarChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.radarChart) this.radarChart.dispose()
    if (this.barChart) this.barChart.dispose()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initRadarChart() {
      this.radarChart = echarts.init(this.$refs.radarChart)
      var maxGmv = Math.max.apply(null, platformData.map(function(d) { return d.gmv }))
      var maxOrders = Math.max.apply(null, platformData.map(function(d) { return d.orders }))
      var maxAvgPrice = Math.max.apply(null, platformData.map(function(d) { return d.avgPrice }))
      var option = {
        tooltip: {
          backgroundColor: 'rgba(6,30,60,0.9)',
          borderColor: 'rgba(0,212,255,0.3)',
          textStyle: { color: '#FFFFFF', fontSize: 12 }
        },
        legend: {
          data: platformData.map(function(d) { return d.name }),
          textStyle: { color: '#B0D4F1', fontSize: 10 },
          top: 0,
          itemWidth: 10,
          itemHeight: 10
        },
        radar: {
          indicator: [
            { name: 'GMV', max: 100 },
            { name: '订单量', max: 100 },
            { name: '转化率', max: 100 },
            { name: '客单价', max: 100 },
            { name: '利润率', max: 100 }
          ],
          radius: '55%',
          center: ['50%', '45%'],
          shape: 'polygon',
          splitArea: {
            areaStyle: {
              color: ['rgba(0,212,255,0.02)', 'rgba(0,212,255,0.05)']
            }
          },
          axisLine: {
            lineStyle: { color: 'rgba(0,212,255,0.15)' }
          },
          splitLine: {
            lineStyle: { color: 'rgba(0,212,255,0.1)' }
          },
          axisName: {
            color: '#B0D4F1',
            fontSize: 10
          }
        },
        series: [{
          type: 'radar',
          data: platformData.map(function(p) {
            return {
              name: p.name,
              value: [
                (p.gmv / maxGmv * 100).toFixed(1),
                (p.orders / maxOrders * 100).toFixed(1),
                (p.conversion / 5 * 100).toFixed(1),
                (p.avgPrice / maxAvgPrice * 100).toFixed(1),
                (100 - p.refundRate).toFixed(1)
              ],
              lineStyle: { color: p.color, width: 1.5 },
              areaStyle: { color: p.color + '26' },
              itemStyle: { color: p.color },
              symbol: 'circle',
              symbolSize: 4
            }
          })
        }]
      }
      this.radarChart.setOption(option)
    },
    initBarChart() {
      this.barChart = echarts.init(this.$refs.barChart)
      var option = {
        tooltip: {
          backgroundColor: 'rgba(6,30,60,0.9)',
          borderColor: 'rgba(0,212,255,0.3)',
          textStyle: { color: '#FFFFFF', fontSize: 12 },
          formatter: function(p) {
            return p.name + '<br/>GMV: ' + (p.value / 10000).toFixed(0) + '万元'
          }
        },
        grid: {
          left: 50,
          right: 50,
          top: 5,
          bottom: 5
        },
        xAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'category',
          data: platformData.map(function(d) { return d.name }),
          axisLine: { lineStyle: { color: 'rgba(0,212,255,0.3)' } },
          axisLabel: { color: '#B0D4F1', fontSize: 10 },
          axisTick: { show: false }
        },
        series: [{
          type: 'bar',
          barWidth: 12,
          data: platformData.map(function(p) {
            return {
              value: p.gmv,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: p.color + '66' },
                  { offset: 1, color: p.color }
                ]),
                borderRadius: [0, 4, 4, 0]
              }
            }
          }),
          label: {
            show: true,
            position: 'right',
            color: '#B0D4F1',
            fontSize: 10,
            formatter: function(p) {
              return (p.value / 10000).toFixed(0) + '万'
            }
          }
        }]
      }
      this.barChart.setOption(option)
    },
    handleResize() {
      if (this.radarChart) this.radarChart.resize()
      if (this.barChart) this.barChart.resize()
    }
  }
}
</script>

<style scoped>
.platform-compare {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.chart-radar {
  width: 100%;
  min-height: 140px;
}
.chart-bar {
  width: 100%;
  min-height: 100px;
}
</style>
